import 'fslightbox';

export default class Lightbox {
  // html selector for the component
  static selectorString() {
    return '.js-lightbox';
  }

  constructor(rootNode) {
    this.$refs = {
      rootNode,
    };

    rootNode.addEventListener('click', this.init.bind(this));
  }

  init() {
    const lightbox = new FsLightbox();
    const images = this.getImages();

    if (images.length === 0) return;

    lightbox.props.captions = ["<h2>An example caption.</h2>"];
    lightbox.props.type = "image";
    lightbox.props.sources = images;
    lightbox.open();
  }

  getImages() {
    return this.$refs.rootNode.dataset.images.split(',') || [];
  }
}
